import { render, staticRenderFns } from "./BlockDocumentImportModal.vue?vue&type=template&id=2359a67e"
import script from "./BlockDocumentImportModal.vue?vue&type=script&lang=js"
export * from "./BlockDocumentImportModal.vue?vue&type=script&lang=js"
import style0 from "./BlockDocumentImportModal.vue?vue&type=style&index=0&id=2359a67e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports